import styled from "styled-components";

export const ErrorMessageStyled = styled.div`
  position: absolute;
  font-size: 13px;
  margin: 5px 0;
  color: red;
`;
